import { setUserProperty } from "./trackingService";
import { updateCookie } from "../utils/common";

// Should be used in scripts placed after the Optimize or GTM
// installation or the initialization of the dataLayer variable.

// Not required if the Google Analytics gtag implementation is used.

function gtag() {
  dataLayer.push(arguments);
}

function implementManyExperiments(value, name, read = false) {
  localStorage.setItem((read ? "read_" : "") + "lpExpId", name);
  localStorage.setItem((read ? "read_" : "") + "lpExpVariantId", value);
  setUserProperty((read ? "read_" : "") + "lpCurrentExperimentId", name, read);
  setUserProperty(
    (read ? "read_" : "") + "lpCurrentExperimentVariantId",
    value,
    read
  );
  if (!read) {
    updateCookie({
      lpCurrentExperimentId: name,
      lpCurrentExperimentVariantId: value,
    });
  } else {
    updateCookie({
      read_lpCurrentExperimentId: name,
      read_lpCurrentExperimentVariantId: value,
    });
  }
}

function implementRead(value, name) {
  implementManyExperiments(value, name);
  console.log(`gopt init done for ${name}, ${value}`);
}
function implementWrite(value, name) {
  implementManyExperiments(value, name, false);
}

export const initGoogleOptimize = (read = false) => {
  gtag("event", "optimize.callback", {
    callback: read ? implementRead : implementWrite,
  });
};
